import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import {
  BACKEND_BASE_URL,
  ICountryService,
  IPageResponse,
  IResponseError,
  IPageRequest,
} from "@/services";
import {
  ICountryConfigData,
  ICountryConfigRequest,
  ICountryConfigResponse,
  ICountryData,
  ISolCustomerCommodityType,
} from "@/entities";
import { i18n } from "@/i18n";

export class CountryService implements ICountryService {
  async saveCountryConfig(config: ICountryConfigRequest): Promise<ICountryConfigData | undefined> {
    const { response, error } = await handleResponse<ICountryConfigData, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v2/country`, config)
    );
    if (error) {
      if (error.response?.status === 409 && error.response?.data?.message) {
        Vue.swal({
          title: i18n.t("option.type.error"),
          text: i18n.t(error.response.data.message),
          icon: "warning",
        });
      }
    } else {
      return response?.data;
    }
  }
  async getCountryConfigByCode(code: string): Promise<ICountryConfigResponse | undefined> {
    const { response, error } = await handleResponse<ICountryConfigResponse, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/country/${code}/config`, {})
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
  async getCountries(sort?: IPageRequest): Promise<IPageResponse<ICountryData> | undefined> {
    const params: Record<string, unknown> = {
      size: sort?.size,
      page: sort?.page,
      orderBy: "name",
    };
    const { response, error } = await handleResponse<IPageResponse<ICountryData>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/country`, { params })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getConfig(code: string): Promise<ICountryConfigData | undefined> {
    const params: Record<string, string> = {
      code,
    };
    const { response, error } = await handleResponse<ICountryConfigData, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/config`, { params })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getCommodities(code: string): Promise<ISolCustomerCommodityType | undefined> {
    const { response, error } = await handleResponse<ISolCustomerCommodityType, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/smartcash/v1/commodities/country/` + code, {})
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
